import {AI_PROMO_MSK_OFFSET_MS, AI_PROMO_SCHEDULE, getAiPromoWindow} from './aiPromoSchedule';

const MINUTE_MS = 60 * 1000;

const pad = (value) => String(value).padStart(2, '0');

/**
 * Время начала ежедневной «Битвы с AI Claude Opus» (момент opens расписания —
 * 21:00 по Москве, см. AI_PROMO_SCHEDULE) для анонса события: по Москве и по
 * часам игрока.
 *
 * Местное время считается для сегодняшнего окна (getAiPromoWindow) и по
 * смещению пояса игрока именно в момент начала: у игрока с летним временем
 * разница с Москвой зимой и летом разная. Если пояс игрока совпадает с
 * московским, отдельного местного времени нет — показывать дважды одно и то
 * же незачем.
 *
 * @param {number} [now] - текущий момент (мс)
 * @param {number} [timezoneOffsetMinutes] - смещение пояса игрока в минутах,
 *   как у Date#getTimezoneOffset (UTC − местное); по умолчанию — пояс
 *   браузера в момент начала матча
 * @returns {{mskTime: string, localTime: string|null}} «ЧЧ:ММ»
 */
export const getAiPromoOpensTimes = (now = Date.now(), timezoneOffsetMinutes) => {
  const {opensAt} = getAiPromoWindow(now);
  const {hour, minute} = AI_PROMO_SCHEDULE.opens;
  const mskTime = `${pad(hour)}:${pad(minute)}`;

  const offsetMinutes = timezoneOffsetMinutes ?? new Date(opensAt).getTimezoneOffset();
  const localOffsetMs = -offsetMinutes * MINUTE_MS;
  if (localOffsetMs === AI_PROMO_MSK_OFFSET_MS) {
    return {mskTime, localTime: null};
  }

  // Сдвигаем момент на смещение пояса и читаем UTC-поля — так время не
  // зависит от пояса, в котором выполняется код (тесты, сервер)
  const local = new Date(opensAt + localOffsetMs);
  return {mskTime, localTime: `${pad(local.getUTCHours())}:${pad(local.getUTCMinutes())}`};
};
